/** Performance Lab landing page photography under static CDN. */

export const PL_SHOTS_BASE =
  'web_v2/performance-lab/landing-page/placeholders/pl-shots-new';

const djb2Hash32 = (str: string): number => {
  let hash = 5381;
  for (let i = 0; i < str.length; i += 1) {
    hash = ((hash << 5) + hash) ^ str.charCodeAt(i);
  }
  return hash >>> 0;
};

const CAROUSEL_ORDER_SEED = 'performance-lab-experience-carousel-v1';

export const ALL_PL_SHOT_FILENAMES = [
  '_TS_0145.jpg',
  '_TS_0353.jpg',
  '_TS_0540.jpg',
  '_TS_0185.jpg',
  '_TS_0755.jpg',
  '_TS_0382.jpg',
  '_TS_0154.jpg',
  '_TS_0244.jpg',
  '_TS_0494.jpg',
  '_TS_0053.jpg',
  '_TS_0736.jpg',
  '_TS_0246.jpg',
  '_TS_0252.jpg',
  '_TS_0134.jpg',
  '_TS_0478.jpg',
  '_SAG8810.jpg',
  '_TS_0241.jpg',
  '_TS_0123.jpg',
  '_TS_0650.jpg',
  '_TS_0310.jpg',
  '_TS_0714.jpg',
  '_TS_0677.jpg',
  '_SAG8987.jpg',
  '_TS_0704.jpg',
  '_TS_0063.jpg',
  '_TS_0513.jpg',
  '_TS_0171.jpg',
  '_TS_0360.jpg',
  '_TS_0201.jpg',
  '_SAG9024.jpg',
] as const;

/** Same assets as `ALL_PL_SHOT_FILENAMES`, deterministically shuffled for SSR/client parity. */
export const CAROUSEL_PL_SHOT_FILENAMES: readonly string[] = [...ALL_PL_SHOT_FILENAMES].sort(
  (a, b) => {
    const ha = djb2Hash32(`${CAROUSEL_ORDER_SEED}:${a}`);
    const hb = djb2Hash32(`${CAROUSEL_ORDER_SEED}:${b}`);
    if (ha !== hb) return ha - hb;
    return a.localeCompare(b);
  },
);

export const PL_HERO_FLANK_BASE =
  '/web_v2/performance-lab/landing-page/v2/hero-no-shadow';

export const HERO_FLANK_FILENAMES: readonly string[] = [
  '01.png',
  '02.png',
  '03.png',
  '04.png',
  '05.png',
  '06.png',
  '07.png',
  '08.png',
];
